var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDtuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 275,
    viewBox: "0 0 275 275",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shield-Duo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#000000",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 17 48 L 73 48 L 120 30 L 137 26 L 185 48 L 225 48 L 257 48 L 234 121 L 201 194 L 137 267 L 77 201 L 33 97 L 17 48 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#ffffff",
    stroke: "none",
    d: "M 219.324646 59.009125 L 180.06102 81.742157 L 191.260834 88.209686 L 136.702759 180.746582 L 98.652382 101.101517 L 73.284874 128.731384 L 36.430893 108.94281 L 27.871098 123.354767 L 74.315048 149.993713 L 92.711525 133.602325 L 136.702759 222.674728 L 207.335144 97.491211 L 219.349884 104.429596 L 219.324646 59.009125 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-copy",
    fill: "#0a5e34",
    stroke: "none",
    d: "M 256.145569 30.327271 C 248.740967 31.004517 241.122559 31.361252 233.345566 31.361252 C 195.194824 31.361252 160.856979 22.848755 136.845444 9.260071 L 136.845444 9.258118 C 136.841537 9.258118 136.841537 9.258118 136.841537 9.258118 C 136.841537 9.258118 136.841537 9.258118 136.839508 9.258118 L 136.839508 9.260071 C 112.828323 22.848755 78.486389 31.361252 40.339561 31.361252 C 32.562439 31.361252 24.944355 31.004517 17.537617 30.327271 C 14.481153 92.725113 26.747269 202.74707 136.839508 266.831635 L 136.839508 266.833618 C 136.841537 266.833618 136.841537 266.831635 136.841537 266.831635 C 136.841537 266.831635 136.841537 266.833618 136.845444 266.833618 L 136.845444 266.831635 C 246.937866 202.74707 259.204163 92.725113 256.145569 30.327271 Z M 212.76004 149.035522 C 198.50061 181.590088 175.558868 213.042908 136.842514 238.749298 C 98.122208 213.044876 75.177299 181.588074 60.915024 149.022812 C 46.841831 116.748322 41.883926 83.251465 41.083023 55.219513 C 77.031616 55.064377 110.076569 48.274445 136.841537 35.994629 C 163.608597 48.275681 196.650406 55.064835 232.5961 55.219513 C 231.797165 83.253632 226.839279 116.751328 212.76004 149.035522 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtuIcon);
export default __webpack_public_path__ + "static/media/dtu_icon.ad2f83d0063774c2a775028f9b302c73.svg";
export { ForwardRef as ReactComponent };